import { render } from "./CoverButton.vue?vue&type=template&id=218fa516"
import script from "./CoverButton.vue?vue&type=script&lang=js"
export * from "./CoverButton.vue?vue&type=script&lang=js"

import "./CoverButton.vue?vue&type=style&index=0&id=218fa516&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__